import { CardConfiguration } from "../../typings";

export const getOutrightMarketIds = (cardConfig: CardConfiguration): string[] => {
    const concatArrays = (a, b) => {
        return a.concat(cardConfig[b].outrightMarkets);
    }

    const addUniqueIds = (a, b) => {
        a.indexOf(b.idLive) < 0 && a.push(b.idLive);
        a.indexOf(b.idPreLive) < 0 && a.push(b.idPreLive);
        return a;
    }

    return Object.keys(cardConfig)
            .reduce(concatArrays, [])
            .reduce(addUniqueIds, [])
}